import { FlatListCityGroup } from 'core/entities/flats';
import { cityName } from 'core/utils/city/city-name-prep';

import { Text } from 'components/common/text/text';
import { FlatList } from 'components/flat/flat-list/flat-list';

export enum FlatListGroupPageType {
  starred,
  owner
}

interface FlatListGroupProps {
  className?: string;
  mainHost: string;
  group: FlatListCityGroup;
  flatListGroupPage: FlatListGroupPageType;
  isMobile: boolean;
  starredIdList?: Array<number>;
  hasMaskWhenRemove?: boolean;
}

export const FlatListGroup = (props: FlatListGroupProps) => (
  <li className={props.className}>
    <Text As='h2' size={20} desktopSize={24}>
      {props.flatListGroupPage === FlatListGroupPageType.starred && props.group.city.name}
      {props.flatListGroupPage === FlatListGroupPageType.owner && `Жильё ${cityName(props.group.city)}`}
    </Text>
    <FlatList
      mainHost={props.mainHost}
      flatList={props.group.flatList}
      starredIdList={props.starredIdList}
      isMobileDevice={props.isMobile}
      hasMaskWhenRemove={props.hasMaskWhenRemove}
    />
  </li>
);
